import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { journalSegmentIntroText } from 'donor-elf-web/controllers/funds/fund/journals/journal/segments';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import type { ValidationResult } from 'ember-changeset/types';

interface ComponentArgs {
  allNames: string[];
  selectedNames: string[];
  type: 'Segment' | 'Group';
  onSave: (selectedNames: string[]) => void;
  onCancel: () => void;
}

class Item {
  constructor(name: string, selected: boolean) {
    this.name = name;
    this.selected = selected;
  }

  name: string;
  @tracked selected: boolean;
}

function createNewItemValidation(allNames: string[]): any {
  return {
    name: (
      _key: string,
      newValue: string,
      _oldValue: string,
      _changes: any,
      _content: any,
    ): ValidationResult => {
      if (allNames.some((x) => x.toLowerCase() === newValue.toLowerCase())) {
        return 'Already exists';
      }
      return true;
    },
  };
}

export default class JournalContactDropdownComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);

    this.items = this.args.allNames.map((name) => {
      return new Item(
        name,
        args.selectedNames.some((x) => x === name),
      );
    });
  }

  @tracked items: Item[] = [];
  @tracked newChangeset?: any;
  @tracked showValidationErrors = false;

  journalSegmentIntroText = journalSegmentIntroText;

  get addingNewItem() {
    return this.newChangeset != null;
  }

  @action
  addNewItem() {
    let validation = createNewItemValidation(this.args.allNames);
    this.newChangeset = new Changeset(
      { name: '', selected: false },
      lookupValidator(validation),
      validation,
    );
  }

  @action
  cancelAddNewItem() {
    this.newChangeset = undefined;
  }

  @action
  toggleSelected(item: Item) {
    item.selected = !item.selected;
  }

  @action
  async save(e: any) {
    let selectedNames = this.items.filter((x) => x.selected).map((x) => x.name);
    if (this.addingNewItem) {
      await this.newChangeset.validate();
      if (this.newChangeset.get('isValid')) {
        this.showValidationErrors = false;
        let newName = this.newChangeset.get('name');
        if (isPresent(newName)) {
          selectedNames.push(newName);
        }
      } else {
        this.showValidationErrors = true;
        setTimeout(() => {
          // scroll the names div all the way down to show the validation error
          let namesDiv = e.target
            .closest('.ember-basic-dropdown-content')
            .querySelector('.overflow-auto');
          namesDiv.scrollTop = namesDiv.scrollHeight;
        });
        return;
      }
    }

    this.args.onSave(selectedNames);
  }
}
